<template>
  <BOverlay
    id="scroll"
    :show="loading"
    spinner-variant="primary"
    variant="light"
    blur="0"
    opacity=".5"
    rounded="sm"
  >
    <div
      id="talent-table"
    >
      <BTable
        :items="items"
        :fields="fields"
        responsive
        show-empty
        class="zero-padding-td-b-table bordered-body-b-table"
      >
        <template #empty>
          <div
            class="col-span-3 flex flex-col gap-[.75rem] items-center text-center py-[5rem]"
          >
            <div class="inline-block aspect-ratio--1x1 rounded-lg bg-[#F5F5F5] p-[.5rem] mx-auto">
              <feather-icon
                icon="ListIcon"
                size="20"
              />
            </div>
            <p class="m-0 font-medium text-xl text-black">
              Belum Ada Talent Aktif
            </p>
            <p class="m-0 w-[300px]">
              Data talent akan muncul disini jika kamu sudah menambahkan data.
            </p>
          </div>
        </template>
        <template #cell(talent_name)="data">
          <div class="p-[.75rem]">
            <TalentRow
              :data="data.item"
              align-center
              with-badge
              :with-dot-icon="data.item.has_active_churn_request"
            >
              <template #subTitle>
                <span>{{ data.item.talent_id }}</span>
              </template>
            </TalentRow>
          </div>
        </template>
        <template #cell(talent_lead)="data">
          <div class="p-[.75rem]">
            <TalentRow :data="{ talent_name: data.item.staff_name }">
              <template #subTitle>
                <span>{{ data.item.staff_id }}</span>
              </template>
            </TalentRow>
          </div>
        </template>
        <template #cell(device)="data">
          <div class="py-[.75rem] px-[1rem]">
            <span>{{ data.item.device }}</span>
          </div>
        </template>
        <template #cell(assign_at)="data">
          <div class="py-[.75rem] px-[1rem]">
            <p class="mb-0">
              {{ data.item.published_date ? DDMMYYYY(data.item.published_date) : '-' }}
            </p>
          </div>
        </template>
        <template #cell(action)="data">
          <div class="flex justify-center">
            <BDropdown
              variant="link"
              no-caret
              right
            >
              <template #button-content>
                <img
                  src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/more.svg"
                  alt="more-icon"
                  class="rotate-90"
                >
              </template>

              <BDropdownItem
                v-for="act in actions"
                :key="act"
                @click="$emit('on-action', { action: act, item: data.item })"
              >
                {{ act }}
              </BDropdownItem>
            </BDropdown>
          </div>
        </template>
      </BTable>
    </div>
  </BOverlay>
</template>

<style scoped>
::v-deep #talent-table .table-responsive {
  height: 50vh;
  overflow-y: auto;
}
</style>

<script>
import { DDMMYYYY } from '@/libs/filterDate'
import { tableTalentList, TALENT_ACTION } from './config'
import TalentRow from './TalentRow.vue'

export default {
  components: { TalentRow },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fields: tableTalentList,
      actions: [
        TALENT_ACTION.ACTION_EDIT_DEVICE,
        TALENT_ACTION.ACTION_EDIT_TL,
        TALENT_ACTION.ACTION_EDIT_OFFICE,
        TALENT_ACTION.ACTION_FORCE_OFF,
      ],
      DDMMYYYY,
    }
  },
  computed: {
    //
  },
}
</script>
